import { Timer } from "./timer.js";
export default function (callback, delay, time) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart(function (elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-timer/src/timeout.js
// module id = 229
// module chunks = 0 1 2